import { render, staticRenderFns } from "./addProcessEvaluate.vue?vue&type=template&id=511d82f2&scoped=true&"
import script from "./addProcessEvaluate.vue?vue&type=script&lang=js&"
export * from "./addProcessEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./addProcessEvaluate.vue?vue&type=style&index=0&id=511d82f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d82f2",
  null
  
)

component.options.__file = "addProcessEvaluate.vue"
export default component.exports